import socket, { invokeRPC } from './socket.js'

export function newFeedback(data) {
  return invokeRPC('feedback', 'newFeedback', {
    subject: data.subject,
    message: data.message,
    parameters: data.parameters,
    browser: data.browser,
    url: data.url,
    origin: data.origin,
    data: {
      route: data.route,
      state: data.state,
      type: data.type,
      isInsights: data.isInsights
    }
  })
}

export function getFeedbackReport(id) {
  return invokeRPC('feedback', 'getFeedbackReport', { id })
}

export function getFeedback() {
  return invokeRPC('feedback', 'getFeedback')
}

export function getFeedbackByUserId(id) {
  return invokeRPC('feedback', 'getFeedbackByUserId', { id })
}

export function getFeedbackResponses(feedback_id) {
  return invokeRPC('feedback', 'getFeedbackResponses', { feedback_id })
}

export function sendFeedbackResponse(data) {
  return invokeRPC('feedback', 'sendFeedbackResponse', {
    feedback_id: data.feedback_id,
    user_name: data.user_name,
    email: data.email,
    user_message: data.user_message,
    respondee: data.respondee,
    response_message: data.response_message
  })
}

export function editFeedbackResponse(data) {
  return invokeRPC('feedback', 'editFeedbackResponse', {
    feedback_id: data.id,
    message: data.message,
    respondee: data.respondee
  })
}

export function deleteFeedbackResponse(id) {
  return invokeRPC('feedback', 'deleteFeedbackResponse', { id })
}

export function updateStatus(data) {
  return invokeRPC('feedback', 'updateStatus', {
    id: data.id,
    status: data.status
  })
}

export function notifyClientOfStatusChange(data) {
  return invokeRPC('feedback', 'notifyClientOfStatusChange', {
    status: data.status,
    feedback_id: data.feedback_id,
    user_name: data.user_name,
    user_message: data.user_message,
    user_email: data.user_email,
    admin_name: data.admin_name
  })
}

export function deleteFeedback(id) {
  return invokeRPC('feedback', 'deleteFeedback', { id })
}

export function sendHowToFeedback(data) {
  return invokeRPC('feedback', 'sendHowToFeedback', {
    question: data.question,
    details: data.details
  })
}

export function sendFeedbackForEmbedSite(data) {
  return invokeRPC('feedback', 'sendFeedbackForEmbedSite', {
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    message: data.message,
    url: data.url,
    site: data.site,
    browser: data.browser
  })
}
